import React from 'react';
import { visualHighlights } from '../../data/mock';

const VisualHighlights = ({ images }) => {
  const displayImages = images || visualHighlights;
  
  return (
    <section className="bg-white py-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 -mt-32 relative z-20">
          {displayImages.map((item, index) => (
            <div
              key={item.id}
              className="relative overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border-2 border-white"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="aspect-[4/3] overflow-hidden border-4 border-white">
                <img
                  src={item.image}
                  alt={item.alt || ''}
                  className="w-full h-full object-cover"
                  loading="eager"
                  decoding="async"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VisualHighlights;
